import React, { useState } from "react";
import { useEffect } from "react";
import { LuLogOut } from "react-icons/lu";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [bookingInfo, setbookingInfo] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setUserInfo(JSON.parse(localStorage.getItem("userInfo")));

    const fetchData = async () => {
      const result = await axios.get(
        "https://laser-treat-server.onrender.com/api/get-all-bookings"
      );
      setbookingInfo(result.data);
    };

    fetchData();
  }, []);

  console.log(bookingInfo);

  const userBookings = bookingInfo?.filter((item) =>
    item.fullName.toLowerCase().includes(userInfo.username.toLowerCase())
  );

  return (
    <div className="profile">
      <div className="user-details">
        <div className="user">
          <h2>Hello, {userInfo?.username}</h2>
          <p>+{userInfo?.phone}</p>
        </div>

        <button
          onClick={() => {
            localStorage.clear();
            navigate("/");
            window.location.reload(false);
            toast.success("Logout Successfull!");
          }}
          className="logout"
        >
          <span>logout</span>
          <LuLogOut className="ico" style={{ marginLeft: "0.3rem" }} />
        </button>
      </div>
      {userBookings.length !== 0 ? (
        <div className="bookings">
          <table>
            <th>
              <td>Doctor</td>
              <td>Date</td>
              <td>Email</td>
              <td>Payment Method</td>
              <td>Booking Reason</td>
            </th>
            {userBookings?.map((el, i) => {
              return (
                <tr key={i}>
                  <td>{el.doctor}</td>
                  <td>{el.date}</td>
                  <td>{el.userEmail}</td>
                  <td>{el.payMethod}</td>
                  <td>{el.message}</td>
                </tr>
              );
            })}
          </table>
        </div>
      ) : (
        <div>
          <p className="noResult">No bookings found with this name - {userInfo?.username}</p>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
